import { SmartComponent } from "smart-component-js";
import Swiper, { Navigation, Pagination } from "swiper";

class TripleCarouselLandingComponent extends SmartComponent {
  constructor(element, parentComponent, params) {
    super(element, parentComponent, params);
    this.element = element;
    this.init();
  }

  init() {
    if (typeof Swiper === "undefined") {
      console.error("Swiper non è definito.");
      return;
    }

    this.swiper = new Swiper(
      this.element.querySelector(".triple-carousel__container"),
      {
        spaceBetween: 20,
        slidesPerView: "auto",
        modules: [Navigation, Pagination],
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          init: () => {
            this.updateNavigationButtons();
          },
          slideChange: () => {
            this.updateNavigationButtons();
          },
        },
        breakpoints: {
          768: {
            slidesPerView: "auto",
          },
          1024: {
            slidesPerView: 2,
          },
          1280: {
            slidesPerView: 2.5,
          },
          1440: {
            slidesPerView: 3,
          },
          1600: {
            slidesPerView: 3,
          },
        },
      }
    );
  }

  updateNavigationButtons() {}
}

export default TripleCarouselLandingComponent;
